import { forwardRef, useCallback, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { IStringOption } from "Dashboard/domain/IStringOption";
import { toast } from "react-toastify";

const ItemCodeSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IStringOption[]>([]);
  const [value, setValue] = useState<IStringOption | undefined>(undefined);

  const knownItemCodes = props.knownItemCodes;


  useEffect(() => {
    async function getData() {
      const op = knownItemCodes.map((code: string) => {
        return {
          label: code,
          value: code,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, [knownItemCodes]);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  const addOption = useCallback((search: string): IStringOption => {
    try {
      const newOption: IStringOption = {
        label: search,
        value: search,
      };
      setOptions([...options, newOption]);
      return newOption;
    } catch (err) {
      throw err;
    }
  }, [options]);

  const handleCreate = (inputValue: any) => {
    try {
      if (!isLoading) {
        const newOption = addOption(inputValue);
        handleChange(newOption, null);
      } else {
        toast.warning("Nisu učitane šifre artikla, ne možete koristiti ovo polje dok se ne učitaju");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p>{inputValue}</p>;
  };

  useEffect(() => {
    if (!isLoading) {
      const values = options.filter((o) => o.value === props.value);
      if (values[0]) {
        setValue(values[0]);
      } else {
        setValue(undefined);
        props.onChange(null);
      }
    }
  }, [options, props.value, props, isLoading]);

  const noOptionsMessage = ({ inputValue }: { inputValue: string }) => {
    return null;
  };

  return (
    <CreatableSelect
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      isClearable
      placeholder=""
      formatCreateLabel={formatCreate}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      options={options}
      noOptionsMessage={noOptionsMessage}
      value={value || ''}
      {...{ error: props.error }}
    />
  );
});

export default ItemCodeSelect;
